import { render, staticRenderFns } from "./Bam.vue?vue&type=template&id=9d01bc1c&scoped=true&"
import script from "./Bam.vue?vue&type=script&lang=js&"
export * from "./Bam.vue?vue&type=script&lang=js&"
import style0 from "./Bam.vue?vue&type=style&index=0&id=9d01bc1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d01bc1c",
  null
  
)

export default component.exports